import { render } from "./_ProfileId.vue?vue&type=template&id=0a77e650"
import script from "./_ProfileId.vue?vue&type=script&lang=js"
export * from "./_ProfileId.vue?vue&type=script&lang=js"

import "./_ProfileId.vue?vue&type=style&index=0&id=0a77e650&lang=scss"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__